 <div *ngIf="status === 'declined'">
     <div class="alertbox error">
         <div class="icon">
             <img src="assets/img/icon/error.png" alt="Error">
         </div>
         <h4>{{ "Declined" | translate }}</h4>
         <p>
             <b>{{ "Your transaction has been declined" | translate }}</b>
         </p>
     </div>
 </div>

 <div *ngIf="status === 'success'">
     <div class="alertbox success">
         <div class="icon">
             <img src="assets/img/icon/success.png" alt="Success">
         </div>
         <h4>{{ "Congrats" | translate }}</h4>
         <p>
             <b> {{ transactionInfo?.amount }} {{ transactionInfo?.currency }} </b>
             {{ "transaction successfully completed" | translate }}
         </p>
     </div>
 </div>